import { CoachingConfiguration, CoachingTaskRun } from "./types";

type TaskDefinitionLike = {
  configuration: string;
};

export const parseCoachingConfiguration = (
  taskDefinition: TaskDefinitionLike | null
): CoachingConfiguration | null => {
  if (!taskDefinition) {
    return null;
  }

  try {
    const config = JSON.parse(taskDefinition.configuration);
    return {
      customInstructions: config.custom_instructions || "",
      sendEmail: config.send_email || false,
      filter: config.filter || null,
    };
  } catch (error) {
    return null;
  }
};

export const stringifyCoachingConfiguration = (
  configuration?: CoachingConfiguration
): string => {
  const payload: Record<string, unknown> = {
    filter: configuration?.filter || null,
  };
  // eslint-disable-next-line camelcase
  payload.custom_instructions = configuration?.customInstructions || "";
  // eslint-disable-next-line camelcase
  payload.send_email = configuration?.sendEmail || false;

  return JSON.stringify(payload);
};

export const getMarkdown = (taskRun: CoachingTaskRun): string => {
  if (!taskRun) {
    return "";
  }

  try {
    const output = JSON.parse(taskRun.output);
    return output?.preview_markdown || "";
  } catch (error) {
    return "";
  }
};
